import { Box } from "@mui/material";
import { AccessibilityInfo } from "../accessibility/AccessibilityInfo";
import { FloatingInfo } from "../floating/FloatingInfo";
export function HomePagePermissions(){
    return (<Box>
        <AccessibilityInfo />   
        <FloatingInfo />
    </Box>)
}